import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/DentalLab.css"; // sende farklıysa aynı css'i bırak
import { FiMail, FiPhone, FiMapPin, FiSearch } from "react-icons/fi";

export default function DentalLab() {
  const { t } = useTranslation();
  const [q, setQ] = useState("");

  const brandDesc = t("dentalLab.modules.brandDesc");

  const brands = useMemo(
    () => [
      {
        key: "straumann",
        title: "STRAUMANN ITI",
        desc: brandDesc,
        phones: ["312 433 3000"],
        emails: ["info.tr@straumann.com"],
        addresses: [
          "Kızılırmak Mah. 1445 Sok. No:2/A, Paragon Tower A Katı A17 Nolu Bölüm, Çukurambar, Çankaya / ANKARA, Türkiye",
          "Fulya Mah. Büyükdere Cad. Akıncı Bayırı Sok. No:74, Torun Center D Blok K.19 No:79/80/81/82, Şişli / İSTANBUL, Türkiye",
        ],
      },
      {
        key: "dentsply",
        title: "DENTSPLY SIRONA",
        desc: brandDesc,
        phones: ["850 755 37 37"],
        emails: ["contact@dentsplysirona.com"],
        addresses: [
          "Barbaros Mah. Mor Sümbül Sk. No:7/3, Nida Kule Güney K:12 Batı, Ataşehir, İstanbul, Türkiye 34746",
        ],
      },
      {
        key: "evoss",
        title: "EVOSS IMPLANT",
        desc: brandDesc,
        phones: ["232 257 55 64"],
        emails: ["info@evoimplant.com"],
        addresses: ["Pancar Mahallesi, Göl Sokak No:52/A, Torbalı, İzmir, Türkiye"],
      },
      {
        key: "nobel",
        title: "NOBEL BIOCARE (Distributor)",
        desc: t("dentalLab.distributorDesc"),
        phones: ["212 361 49 01"],
        emails: ["info@eotdental.com"],
        addresses: [
          "EOT Dental Sağlık Ürünleri ve Dış Tic. A.Ş. (distributor), Nispetiye Mah. Aytar Cd. No:10, Metro İş Merkezi Kat:3 Daire:7, Beşiktaş, İstanbul, Türkiye",
        ],
      },
      {
        key: "nucleoss",
        title: "NUCLEOSS",
        desc: brandDesc,
        phones: ["232 799 03 04"],
        emails: ["info@nucleoss.com"],
        addresses: [
          "İTOB Organize Sanayi Bölgesi, İTOB Atatürk Caddesi No:24, 35477 Tekeli | Menderes | İzmir | Türkiye",
        ],
      },
    ],
    [brandDesc, t]
  );

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return brands;
    return brands.filter((b) => {
      const hay = [
        b.title,
        b.desc,
        ...(b.phones || []),
        ...(b.emails || []),
        ...(b.addresses || []),
      ]
        .join(" ")
        .toLowerCase();
      return hay.includes(s);
    });
  }, [q, brands]);

  return (
    <div className="lab-page">
      <div className="lab-head">
        <h1 className="lab-title">{t("dentalLab.title")}</h1>
        <p className="lab-sub">{t("dentalLab.subtitle")}</p>

        {/* Arama */}
        <div className="lab-search">
          <FiSearch />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder={t("dentalLab.searchPlaceholder")}
          />
        </div>
      </div>

      <div className="brand-grid">
        {filtered.map((b) => (
          <div className="brand-card" key={b.key}>
            <div className="brand-top">
              <div className="brand-title">{b.title}</div>
              <div className="brand-desc">{b.desc}</div>
            </div>

            <div className="brand-section">
              <div className="brand-row">
                <FiPhone />
                <div className="brand-col">
                  {(b.phones || []).map((p, i) => (
                    <a
                      key={i}
                      className="brand-link"
                      href={`tel:${p.replace(/\s+/g, "")}`}
                    >
                      {p}
                    </a>
                  ))}
                </div>
              </div>

              <div className="brand-row">
                <FiMail />
                <div className="brand-col">
                  {(b.emails || []).map((m, i) => (
                    <a key={i} className="brand-link" href={`mailto:${m}`}>
                      {m}
                    </a>
                  ))}
                </div>
              </div>

              <div className="brand-row">
                <FiMapPin />
                <div className="brand-col">
                  {(b.addresses || []).map((ad, i) => (
                    <div key={i} className="brand-text">
                      {ad}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* İstersen marka sayfası/ürün linkleri eklenebilir */}
            {/* <div className="brand-actions">
              <button className="btn">Detay</button>
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
}
